export default __webpack_public_path__ + "static/media/graphic-cookie-notice.70ec9ea7.svg";